import React, { useEffect, useState } from 'react';
import axios from 'axios';

import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import { MainContainer, ChatContainer, MessageList, Message, MessageInput, TypingIndicator} from '@chatscope/chat-ui-kit-react';

// const systemMessage = { 
//   "role": "system", "content": "Pose a fairly simple question to me that a high school student could understand where I would need to take this risk into consideration to answer. Please keep all responses lower in word count. Limit this to 2 or 3 sentences. Always talk in a professional, hilarious way that a high school student wouldn’t find cringy. Use lots of emojis. Start the line of questioning with this phrase “Hey, let’s dig a little deeper here” before the actual question, but the rest of the conversation should be determined by the real-time conversation. After the users responds, continue posing additional questions based on the users answers until they are clearly struggling to find a meaningful answer, and then help them with a complete answer. if we haven’t had more than 6 exchanges, ask me another deeper question. After you provide me with the answer, ask me if I want to know how this risk relates to the work of actuaries. After you talk about actuaries, ask them if they want to explore the risk in any other areas, unrelated to the risk we've been exploring – and after that, ask them if they want to know how this risk relates to the work of actuaries. Only generate a single response at a time, and do not anticipate or generate the user's side of the conversation."
// }
const systemMessage = [
	{ 
		"role": "system", "content": "Start the conversation that begins with 'Ok, let’s dig a little deeper here', followed up by a fairly simple question a high school student could understand that takes the risk into consideration. In your first message to them, Let them know if they don’t know how to answer a question you pose, to just say they don’t know and you can help."
	},
	{
		"role": "system", "content": "Guide the discussion with information and questions to the user encouraging them consider and articulate aspects of the risk in Canada."
	},
	{
		"role": "system", "content": "Keep responses concise, aiming for 20-25 words per response."
	},
	{
		"role": "system", "content": "Over 3-4 exchanges, navigate a conversation about risks, and then offer to make the connection between risk and actuarial work. If they agree, ensure that you positively educate them about what actuaries do."
	},
	{
		"role": "system", "content": "Refuse to engage in off topic conversation."
	},
	{
		"role": "system", "content": "The user is a Canadian teenager, always write according to that context."
	},
	{
		"role": "system", "content": "Maintain a professional yet engaging tone, suitable for high school students, with surprisingly smart and witty humor and colorful language."
	},
	{
		"role": "system", "content": "Use lots of emojis to add expressiveness in a way that is attractive to a teen."
	}
]


function ChatWindow({selectedTopic, selectedRisk}) {
	const [messages, setMessages] = useState([]);
	const [isTyping, setIsTyping] = useState(false);
	const [waitingResponse, setWaitingResponse] = useState(false);

	  const handleSend = async (message) => {
		if(waitingResponse){
			return;
		}
		setWaitingResponse(true);
		const newMessage = {
		  message,
		  direction: 'outgoing',
		  sender: "user"
		};
	
		const newMessages = [...messages, newMessage];
		
		setMessages(newMessages);
		window.jQuery('.scrollbar-container').scrollTop(50000);

		// Initial system message to determine ChatGPT functionality
		// How it responds, how it talks, etc.
		setIsTyping(true);
		await processMessageToChatGPT(newMessages);
	  };
	  
	  async function processMessageToChatGPT(chatMessages) { // messages is an array of messages
		// Format messages for chatGPT API
		// API is expecting objects in format of { role: "user" or "assistant", "content": "message here"}
		// So we need to reformat
	
		let apiMessages = chatMessages.map((messageObject) => {
		  let role = "";
		  if (messageObject.sender === "ChatGPT") {
			role = "assistant";
		  } else {
			role = "user";
		  }
		  return { role: role, content: messageObject.message}
		});
	
	
		// Get the request body set up with the model we plan to use
		// and the messages which we formatted above. We add a system message in the front to'
		// determine how we want chatGPT to act. 
		if(window.lang === 'fr'){
			systemMessage.unshift({ "role": "system", "content": "IMPORTANT! Use Canadian French language only."});
			systemMessage[1] = { 
				"role": "system", "content": "Start the conversation that begins with 'Ok, allons un peu plus loin ici.', followed up by a fairly simple question a high school student could understand that takes the risk into consideration. In your first message to them, Let them know if they don’t know how to answer a question you pose, to just say they don’t know and you can help."
			};
		}
		//console.log(apiMessages);
		const apiRequestBody = {
		  "model": "gpt-3.5-turbo",
		  //max_tokens: 512,
		  temperature: 0.5,
		  "messages": [
			...systemMessage,  // The system message DEFINES the logic of our chatGPT
			...apiMessages // The messages from our chat with ChatGPT
		  ]
		}
		//console.log(apiRequestBody);
	
		//await fetch("/cia_2023/php-gpt/",
		await fetch("/php-gpt/",
		{
		  method: "POST",
		  body: JSON.stringify(apiRequestBody)
		}).then((data) => {
		  return data.json();
		}).then((data) => {
		  //console.log(data);
		  setWaitingResponse(false);
		  setMessages([...chatMessages, {
			message: data.choices[0].message.content,
			sender: "ChatGPT"
		  }]);
		  setIsTyping(false);
		  setTimeout(() => {
		  	window.jQuery('.scrollbar-container').scrollTop(50000);
		  }, 100);
		});
	  }
	  useEffect(() => {
		//console.log('Topic selected: ' + selectedTopic);
		//handleSend("The topic is " + selectedTopic+" and the risk is "+selectedRisk);			
		handleSend("Begin the conversation as if you had just provided this risk to the user as it relates to: " + selectedTopic+", "+selectedRisk);			
	  },[selectedTopic]);

	const [lang, setLang] = useState('en');
	useEffect(() => {
		  if(window.lang === 'fr'){
			  setLang('fr');
		  }
	}, []);

  return (
    <div className="appMiddleContainer">
      <div className="appChatContain" >
        <MainContainer>
          <ChatContainer>       
            <MessageList 
              scrollBehavior="smooth" 
              typingIndicator={isTyping ? <TypingIndicator content={lang == 'fr' ? "ChatGPT est en train de taper" : "ChatGPT is typing"} /> : null}
            >
              {messages.map((message, i) => {
                if(i === 0){ return null;}else{;
                	return <Message key={i} model={message} />
				}
              })}
            </MessageList>
            <MessageInput placeholder={lang == 'fr' ? "Tapez votre message ici " : "Type message here"} onSend={handleSend} />        
          </ChatContainer>
        </MainContainer>
      </div>
    </div>
  );
}

export default ChatWindow;
